export enum EditUserItemId {
  AvailableEditUserTag = 'editableUserTag',
  AffiliateTag = 'showAffiliate',
  CompanyGroupTag = 'showCompanyGroup',
  CompanyTag = 'showCompany',
  TenantTag = 'showTenant',
  SelectableAffiliate = 'selectableAffiliate',
  SelectableCompanyGroup = 'selectableCompanyGroup',
  SelectableCompany = 'selectableCompany',
  SelectableTenant = 'selectableTenant',
  TelephoneNumber = 'requiredTelephoneNumber',
  ShowAutomaticLogout = 'showAutomaticLogout',
  ShowErrorNotificationSetting = 'showErrorNotificationSetting',
  EditableAutomaticLogout = 'editableAutomaticLogout',
  EditableErrorNotificationSetting = 'editableErrorNotificationSetting',
  ShowCommunicationErrorNotification = 'showCommunicationErrorNotification',
  EditableCommunicationErrorNotification = 'editableCommunicationErrorNotification',
}
